import SwitchLanguageButton from '@/components/SwitchLanguageBtn';
import { LanguageContext } from '@/contexts';
import { PUBLIC_ROUTES } from '@/routes/routes';
import { ColumnsSettingContext, IColumnSettingsPayload } from '@/utils';
import { Icon, Loading } from '@amili-v3/amili-v3-design';
import { ConfigProvider } from 'antd';
import classNames from 'classnames';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import '../form/zod.config';
import Router from './Router';
import './styles.scss';
import { defaultTheme } from './theme';

const publicRouteValues = Object.values(PUBLIC_ROUTES);

const App = () => {
  const { pathname } = useLocation();
  const [columnsList, setColumnsList] = useState<IColumnSettingsPayload[]>([]);
  const { t } = useTranslation();

  const [shouldShowAnimationBackground, setShouldShowAnimationBackground] =
    useState(publicRouteValues.includes(pathname as any));

  const { isLoading: isLoadingLanguage } = useContext(LanguageContext);

  const locale = useMemo(() => {
    return { locale: '', Empty: { description: t('design.noData') } };
  }, [t]);

  useEffect(() => {
    setShouldShowAnimationBackground(
      publicRouteValues.includes(pathname as any),
    );
  }, [pathname]);

  return (
    <ConfigProvider locale={locale} theme={defaultTheme}>
      <ColumnsSettingContext.Provider
        value={{ columns: columnsList, setColumnsSetting: setColumnsList }}
      >
        <div
          className={classNames('app', {
            'animation-background': shouldShowAnimationBackground,
          })}
        >
          {/* {canShowStackName && (
            <span className="stack-name">
              {t(`stack.${process.env.REACT_APP_STACK_TYPE}`)}
            </span>
          )} */}
          {isLoadingLanguage ? (
            <Loading />
          ) : (
            <>
              {publicRouteValues.includes(pathname as any) && (
                <SwitchLanguageButton position="fixed" />
              )}
              {publicRouteValues.includes(pathname) && (
                <Icon
                  name={'logoLilac'}
                  width={96}
                  height={32}
                  color="white"
                  style={{
                    position: 'relative',
                    paddingLeft: 36,
                    paddingTop: 24,
                  }}
                />
              )}
              <Router />
            </>
          )}
          {/* {readyToRenderRoutes ? <Router /> : <LoadingStyle />} */}
        </div>
      </ColumnsSettingContext.Provider>
    </ConfigProvider>
  );
};

export default App;
